import {Injectable} from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class Helper {
    static round(value, decimal = 2, forceReturnNumber = true) {
        value = parseFloat(value);
        if (isNaN(value) && forceReturnNumber) {
            return 0;
        }
        return Math.round(value * Math.pow(10, decimal)) / Math.pow(10, decimal);
    }

    static fixedDecimals(value, decimal = 2, forceReturnNumber = true) {
        value = parseFloat(value);
        if (isNaN(value) && forceReturnNumber) {
            return 0;
        }
        return value.toFixed(decimal);
    }

    static getYearArray(baseYear = 1965): Array<number> {
        const years = [];
        const currentYear: any = moment(new Date()).format('YYYY');
        while (baseYear <= currentYear) {
            years.push(baseYear);
            baseYear++;
        }
        return years;
    }

    static uniqByKeepLast(data, key) {
        return [
            // @ts-ignore
            ...new Map(data.map(x => [key(x), x])).values()
        ];
    }

    static getMonthWeeks(month: number, year: number) {
        const days = [];
        const monetEndDate = moment().month(month - 1).year(year).endOf('month');
        let currentDate = moment(monetEndDate).startOf('month');
        while (currentDate.isSameOrBefore(monetEndDate)) {
            const startDate = moment(currentDate).startOf('isoWeek').set({hour: 0, minute: 0, second: 0, millisecond: 0});
            const endDate = moment(currentDate).endOf('isoWeek').set({hour: 23, minute: 59, second: 59, millisecond: 999});
            days.push({
                week: startDate.format('DD MMM') + '-' + endDate.format('DD MMM'),
                startDate: moment(currentDate).startOf('isoWeek'),
                endDate: moment(currentDate).endOf('isoWeek'),
                weekOfYear: startDate.week(),
                weekOfMonth: startDate.week()
            });
            currentDate = currentDate.endOf('isoWeek').add(1, 'day');
        }
        return days;
    }

    static isNumber(value): boolean {
        return !isNaN(value);
    }

    private static precedence(op) {
        if (op === '+' || op === '-') {
            return 1;
        }
        if (op === '*' || op === '/') {
            return 2;
        }
        return 0;
    }

    private static applyOp(a, b, op) {
        switch (op) {
            case '+':
                return a + b;
            case '-':
                return a - b;
            case '*':
                return a * b;
            case '/':
                return a / b;
        }
    }
}
